/**
 * The single HTML-escaper for the whole client. Escapes the five characters
 * that can break out of HTML text or a quoted attribute: & < > " '. Every page
 * builds markup with innerHTML template strings, so ANY player- or server-
 * supplied value interpolated into markup must pass through this first.
 *
 * Do NOT define a local escape helper in a page/component — import this one.
 * The check-escape-html.mjs deploy guard fails the build on local copies, which
 * is how the old divergent copies (some missing the ' escape) crept in.
 */
export function escapeHtml(s: string): string {
  return String(s)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}
